document.addEventListener('DOMContentLoaded', () => {
  const sidebarItemsWithSubmenu = document.querySelectorAll(
    '.medispa-mobile-nav-items .Linklist__Item.has-submenu',
  );

  if (!sidebarItemsWithSubmenu.length) return;

  sidebarItemsWithSubmenu.forEach((sideBarItem) => {
    sideBarItem.addEventListener('click', (e) => {
      if (!(e.target as HTMLElement).closest('a.Heading')) {
        e.preventDefault();

        sideBarItem.classList.toggle('open');
      }
    });
  });
});
